import React from 'react';
import { TasksTableHeader } from './components/TasksTableHeader';
import { TasksTableRow } from './components/TasksTableRow';
import { TasksTableEmpty } from './components/TasksTableEmpty';
import { TasksTableFooter } from './components/TasksTableFooter';
import type { FullIssueWithChildren } from '@/shared/utils/issue-guards';

interface TasksTableProps {
  tasks: FullIssueWithChildren[];
  currentEmployeeId?: string;
}

export const TasksTable: React.FC<TasksTableProps> = ({
  tasks,
  currentEmployeeId,
}) => {
  return (
    <div className="mt-3 bg-white rounded-lg border border-gray-200 overflow-hidden">
      <TasksTableHeader />

      <div className="divide-y divide-gray-100">
        {tasks.map((task) => (
          <TasksTableRow
            key={task._id}
            task={task}
            currentEmployeeId={currentEmployeeId}
          />
        ))}
      </div>

      {tasks.length === 0 && <TasksTableEmpty />}
      {tasks.length > 0 && <TasksTableFooter tasks={tasks} />}
    </div>
  );
};
